module.exports = __webpack_public_path__ + "static/media/documentPlaceholderBill.1e492b95.svg";